import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService, ApiService, AuthService, CalendarService, ConditionService, DialogService, FormulaService, MetadataService, SessionService, TranslatorService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { DialogComponent } from '../../common/dialog/dialog.component';
import { DashboardViewConfig, TableViewConfig } from '../../../models/view-config/table-view-config.model';
import { addMinutes } from 'date-fns';

@Component({
    selector: 'sn-usc-leads-contacted-widgets',
    templateUrl: './usc-leads-contacted-widgets.component.html',
    styleUrls: ['./usc-leads-contacted-widgets.component.css']
})
export class UscLeadsContactedWidgetsComponent implements OnInit {
    @Input() view:string;

    public data_items: Array<any> = [];
    public detail_items: Array<any> = [];
    public filtered_detail_items: Array<any> = [];
    public filter_fields: Array<any> = [];
    public detail_items_loaded: boolean = false;
    public current_filtered_values: any = {}
    private viewConditions: Array<any> = [];
    private viewFormulas: Array<any> = [];
    public columnFields: Array<any> = [];
    public visibleColumnFields: Array<any> = [];
    public formulaColumnFields: Array<any> = [];
    public dashboard_view_config: DashboardViewConfig;
    public sales_mode: string;
    public dataset_date: Date;

    constructor(
        public router: Router,
        public ngbModal: NgbModal,
        public adminService: AdminService,
        public metadataService: MetadataService,
        public authService: AuthService,
        public apiService: ApiService,
        public sessionService: SessionService,
        public conditionService: ConditionService,
        public uscStoreService: UscStoreService,
        public translatorService: TranslatorService,
        public formulaService: FormulaService,
        public dialogService: DialogService,
        public elementRef: ElementRef,
        public calendarService: CalendarService,
    ) {
    }

    ngAfterViewInit() {
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#f0f0f0';
    }
    
    ngOnInit() {
        this.dataset_date = addMinutes(new Date(), -2);
        switch (this.view) {
            case this.uscStoreService.view_dashboard_lead_contacted: this.sales_mode = 'leads_contacted'; break;
            case this.uscStoreService.view_dashboard_scheduled_appts_held: this.sales_mode = 'scheduled_appointments'; break;
        }
        this.loadTableViewMetaData();
    }

    protected loadTableViewMetaData(): void {
        this.detail_items_loaded = false;
        var dashboard_view_config = new DashboardViewConfig();
        this.metadataService.getTableViewMetaData(this.uscStoreService.view_dashboard_lead_contacted, { }, true).subscribe(result => {
            Object.assign(dashboard_view_config, result.meta_data);
            this.dashboard_view_config = dashboard_view_config;

            this.formulaColumnFields = [];
            this.filter_fields = this.dashboard_view_config.filter_fields;

            // load view items here after meta data is downloaded
            this.reloadItems();
        });
    }

    reloadItems(init_filter_fields:boolean = true) {
        // reset state variable before reloading action plans
        // this.filter_fields = [];
        if (init_filter_fields) {
            this.current_filtered_values = {};
        } 
        var detail_items = this.getDetailItems(init_filter_fields);
        // certain views need to query db to get the detail_items, thus not all views returns detail_items immediately.
        // for those that does, we can processDetailItems right away. 
        // for those that doesn't, it is up that view to processDetailItems once the detail_items are available.
        if (detail_items) this.processDetailItems(detail_items, init_filter_fields);
    }

    public getDetailItems(init_filter_fields: boolean): any {
        var dlg = this.dialogService.showLoadingDlg(DialogComponent, { msg: "Loading..." });
        this.uscStoreService.getDashboardMetrics(this.view).subscribe(data => {
            this.data_items = data;
            this.processDetailItems(this.data_items, init_filter_fields);
            dlg.dismiss();
        })
    }

    processDetailItems(detail_items, init_filter_fields:boolean) {
        this.detail_items = detail_items;
        this.filtered_detail_items = this.detail_items;
        this.detail_items_loaded = true;

        this.detail_items.forEach(item => {
            // process all conditions for each item
            if (this.viewConditions) {
                var conditions = JSON.parse(JSON.stringify(this.viewConditions));
                item.viewConditions = this.conditionService.evaluateItemValues(conditions, null, item);
            }
            if (this.viewFormulas) {
                var formula_results = this.formulaService.calculateFormulaValuesByItem(this.viewFormulas, item);
                this.formulaColumnFields.forEach(f => {
                    var fr = formula_results.find(r => r.name == f.sn_calc_formula);
                    if (fr) item[f.key] = fr.result;
                })
            }
        });

        // determine which columns area page filters
        // this.columnFields.forEach(cf => {
        //     if (cf.sn_enable_filtering && this.detail_items.length > 0) {
        //         var condResult = this.conditionService.getCondition(this.detail_items[0].viewConditions, cf.sn_enable_filtering);
        //         cf.enable_filtering = condResult ? condResult.result : cf.enable_filtering;
        //     }
        //     if (cf.is_page_filter && cf.enable_filtering) this.filter_fields.push(cf);
        // })

        this.generateFilterData();
        if (init_filter_fields) this.initFilterFieldSelections();

        this.updateDisplayDetailedItems();
    }

    updateDisplayDetailedItems() {
        this.updateFilteredDetailedItems();
    }

    public initFilterFieldSelections() {
        this.filter_fields.forEach(f => {
            if (f.current_filtered_value == null && f.filter_data && f.filter_data.length > 0) f.current_filtered_value = this.detail_items[0][f.key];
        })
    }

    //#region Data Filters
    updateFilteredDetailedItems() {
        this.filtered_detail_items = [];
        this.detail_items.forEach(ap => {
            var bInclude = true;
            this.filter_fields.forEach(f => {
                if ((f.enable_filtering) && f.current_filtered_value) {
                    bInclude = bInclude && ap[f.key] == f.current_filtered_value;
                }
            })
            if (bInclude) this.filtered_detail_items.push(ap);
        })
        //this.generateFilterData();
    }

    generateFilterData() {
        this.filter_fields.forEach(f => {
            if (f.filter_data == null || f.is_dataset_dependent_filter != false) f.filter_data = this.getDataFilter(f);
        })
    }

    getDataFilter(field) {
        var filter_list = !field.allow_all_as_filter_value ? [] : [{ label: 'All', value: '' }];
        if (this.detail_items_loaded && field.enable_filtering) {
            if (field.filter_data_source == 'data') {
                this.filtered_detail_items.forEach(item => {
                    var field_value = this.getFieldValue(item, field);
                    var filter = filter_list.find(f => f.value == field_value);
                    if (filter == null) {
                        var field_label = this.getFieldFilterDisplay(item, field);
                        filter_list.push({ label: field_label, value: field_value });
                    }
                })
            }
            // dont not sort filter list if filter_value_sort_order is not defined (use the detail_items order)
            if (field.filter_value_sort_order != '') {
                filter_list.sort(function (a, b) {
                    var sort_order = -1; // default: ascending order
                    if (field.filter_value_sort_order == 'desc') sort_order = 1;
                    return (a.value < b.value) ? sort_order : sort_order * -1;
                })
            }
        }
        return filter_list;
    }

    getFieldFilterDisplay(item, field): any {
        if (item && field) {
            return this.getFieldValue(item, field);
        }
        return null;
    }

    showFilteredValue(field): boolean {
        if (field.is_page_filter && field.allow_all_as_filter_value && (field.current_filtered_value == null || field.current_filtered_value == "")) return true;
        return (field && field.current_filtered_value);
    }

    getFilteredValue(field) {
        if (field.is_page_filter && field.allow_all_as_filter_value && (field.current_filtered_value == null || field.current_filtered_value == "")) return 'All';
        return field.current_filtered_value;
    }

    filter(field, f) {
        // this.curPage = 1;
        var campaign = this.filter_fields.find(ff => ff.key == 'campaign');
        field.current_filtered_value = f.value;
        //step 1. try to find a matching record with existing filters first
        var matched_item:any = null;
        for (var x = 0; x < this.detail_items.length; x++) {
            var bMatch = true;
            var item = this.detail_items[x];
            for (var i = 0; i < this.filter_fields.length; i++) {
                var filter_field = this.filter_fields[i];
                bMatch = bMatch && filter_field.current_filtered_value == item[filter_field.key];
                if (!bMatch) break;
            }
            if (bMatch) {
                matched_item = item;
                break;
            } 
        }

        //step 2. if matched_item not found, try to find the first matching record using only the current filter field
        if (field.key != 'campaign' && matched_item == null) {
            var matched_item = this.detail_items.find(item => item[field.key] == f.value);
            if (matched_item != null) {
                // update all other filter_fields with the new matched_item
                this.filter_fields.forEach(ff => {
                    if (ff.key != field.key) {
                        ff.current_filtered_value = matched_item[ff.key];
                    }
                })
            }
        }        
        this.updateDisplayDetailedItems();
    }

    
    //#endregion

    getFieldValue(detail_item, field): any {
        if (detail_item && field) {
            var field_value = detail_item[field.key];
            switch (field.key) {
                default:
                    break;
            }

            return field_value != null ? field_value : 0;
        }
        return null;
    }

    toJson(item) {
        return JSON.stringify(item);
    }

    getDataSetDate(): string {
        return this.calendarService.getDateText(this.dataset_date, "MMMM dd, yyyy hh:mm tt");
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-leads-contacted-widgets/usc-leads-contacted-widgets.component.ts